import useLocalStorage from "react-use-localstorage"

export function useUser() {
  const [user, setUser] = useLocalStorage("user", "")
  return { user, setUser, clearUser: () => setUser("") }
}
